// @ts-nocheck


import { fetchRequest, initialFetchListParams } from './index';


import {
  convertFromKopToRub,
  convertFromRubToKop,
  convertFromSecondToHour,
  convertFromHourToSecond } from
'../pure/unitConversions';

export const convertDataFromServer = (outsourcingAct) => ({
  ...outsourcingAct,
  sum: convertFromKopToRub(outsourcingAct.sum),
  workHoursPrice: convertFromKopToRub(outsourcingAct.workHoursPrice),
  workHours: convertFromSecondToHour(outsourcingAct.workHours)
});

export const convertDataToServer = (outsourcingAct) => ({
  ...outsourcingAct,
  sum: convertFromRubToKop(outsourcingAct.sum),
  workHoursPrice: convertFromRubToKop(outsourcingAct.workHoursPrice),
  workHours: convertFromHourToSecond(outsourcingAct.workHours)
});

export const deleteOutsourcingAct = async (
id) =>
{
  const deleted = await fetchRequest.delete(`/outsourcingAct/${id}`);
  if (deleted) return deleted;
  throw new Error('Не удалось удалить акт оказания услуг');
};

export const addOutsourcingAct = async (
outsourcingAct) =>
{
  const added = await fetchRequest.post(
    '/outsourcingAct',
    convertDataToServer(outsourcingAct)
  );
  if (added) return convertDataFromServer(added);
  throw new Error('Не удалось добавить акт оказания услуг');
};

export const updateOutsourcingAct = async (
outsourcingAct) =>
{
  const updated = await fetchRequest.put(
    '/outsourcingAct',
    convertDataToServer(outsourcingAct)
  );
  if (updated) return convertDataFromServer(updated);
  throw new Error('Не удалось отредактировать акт оказания услуг');
};

export const fetchOutsourcingAct = async (
params = initialFetchListParams) =>
{
  const outsourcingAct = await fetchRequest.get('/outsourcingAct', {
    ...initialFetchListParams,
    ...params
  });
  if (outsourcingAct)
  return {
    ...outsourcingAct,
    data: outsourcingAct.data.map(convertDataFromServer)
  };
  throw new Error('Не удалось получить акты оказания услуг');
};

export const getOutsourcingAct = async (
id) =>
{
  const outsourcingAct = await fetchRequest.get(`/outsourcingAct/${id}`);
  if (outsourcingAct) return convertDataFromServer(outsourcingAct);
  throw new Error('Не удалось получить акт оказания услуг');
};

export default {
  deleteOutsourcingAct,
  addOutsourcingAct,
  updateOutsourcingAct,
  getOutsourcingAct,
  fetchOutsourcingAct
};
